"use client";

import OddsChangePopup from "@/components/OddsChangePopup";
import { TrendOddsDesktop } from "@/components/OddsTrendBadge";
import { desktopOddsBgClass } from "@/components/LiveScoreMatch/oddsTrendClasses";

export default function LiveScoreOddsDesktopCell({
  tdPad,
  isLastCell,
  value,
  trend,
  match,
  popupOpen,
  onMouseEnter,
  onMouseLeave,
}) {
  const bg = desktopOddsBgClass(trend);

  return (
    <td
      className={`${tdPad} group relative min-w-[50px] text-center${isLastCell ? " border-r-0" : ""}`}
      onMouseEnter={onMouseEnter}
      onMouseLeave={onMouseLeave}
    >
      <p
        className={`relative m-0 mr-1 mx-auto flex h-[22px] w-[58px] items-center justify-center rounded-[4px] leading-none md:text-[16px] text-[color:var(--theme-text)] ${bg}`}
      >
        {value || "-"}
        <TrendOddsDesktop trend={trend} />
      </p>
      {popupOpen ? (
        <OddsChangePopup
          match={match}
          visible
          position={{ top: 42, left: -258 }}
          onClose={onMouseLeave}
        />
      ) : null}
    </td>
  );
}
